import {NaverLoginService} from "./naver-login.service";

export const NaverLoginInjectables: Array<any> = [
  {
    provide: NaverLoginService,
    useClass: NaverLoginService,
  },
];
